import { useState } from "react";
import { useFormikContext } from "formik";
import { IconUser, IconUsers } from "@tabler/icons-react";
import ButtonCard from "../../UI/ButtonCard";
import ChoiceCard from "./ChoiceCard";
// @ts-expect-error pure js
import Tabs from "../../UI/Tabs";
// @ts-expect-error pure js
import TextInput from "../../UI/TextInput";
import Button from "../../UI/Button";
import Callout from "../../UI/Callout";
import Text from "../../UI/Text";
import styles from "./TypeLocation.module.css";

interface TypeLocationValues {
  is_coloc?: boolean;
  nb_rooms?: string | number;
}

export default function TypeLocation() {
  const { selectNextTab, selectPreviousTab } = Tabs.useActiveTab();
  const { values, setFieldValue } = useFormikContext<TypeLocationValues>();

  const nbRooms = parseInt(String(values.nb_rooms)) || 0;
  const [showColocChoice, setShowColocChoice] = useState(
    Boolean(values.is_coloc),
  );
  const [individualLeases, setIndividualLeases] = useState(nbRooms > 0);

  function chooseSingleTenant() {
    setFieldValue("is_coloc", false);
    setFieldValue("nb_rooms", 0);
    setShowColocChoice(false);
    setIndividualLeases(false);
    selectNextTab();
  }

  function chooseColoc() {
    setFieldValue("is_coloc", true);
    setShowColocChoice(true);
  }

  function chooseBailUnique() {
    setFieldValue("nb_rooms", 0);
    setIndividualLeases(false);
    selectNextTab();
  }

  function chooseBauxIndividuels() {
    if (!individualLeases) {
      setFieldValue("nb_rooms", "");
    }
    setIndividualLeases(true);
  }

  return (
    <div className={styles.step}>
      <Text>Comment exploitez vous le logement ?</Text>
      <ChoiceCard
        icon={IconUser}
        title={"Un locataire seul ou un couple"}
        subtitle={"Un seul bail pour tout le logement"}
        onClick={chooseSingleTenant}
      />
      <ChoiceCard
        icon={IconUsers}
        title={"Une colocation"}
        subtitle={"Plusieurs locataires, baux individuels ou solidaires"}
        selected={showColocChoice}
        onClick={chooseColoc}
      />
      {showColocChoice && (
        <>
          <Text>Comment sont établis les baux ?</Text>
          <ButtonCard className={styles.card} onClick={chooseBailUnique}>
            Un bail unique pour toute la colocation (colocataires solidaires)
          </ButtonCard>
          <ButtonCard
            className={styles.card}
            selected={individualLeases}
            onClick={chooseBauxIndividuels}
          >
            Des baux individuels, un par chambre
          </ButtonCard>
        </>
      )}
      {showColocChoice && individualLeases && (
        <>
          <Callout variant="warning">
            Dans le cadre d'une colocation avec baux individuels, chaque chambre
            est un bien à part entière (y compris pour l'abonnement). Nous
            allons configurer toutes les chambres d'un coup : le loyer, les
            charges et le dépôt de garantie saisis aux étapes suivantes
            s'appliqueront à chaque chambre. Vous pourrez ensuite personnaliser
            le nom et le loyer de chacune.
          </Callout>
          <TextInput
            name={"nb_rooms"}
            type={"number"}
            label={"Nombre de chambres à créer"}
            mandatory
          />
        </>
      )}
      <div className={styles.footer}>
        <Button variant="secondary" onClick={() => selectPreviousTab()}>
          Précédent
        </Button>
        {showColocChoice && individualLeases && (
          <Button disabled={nbRooms < 1} onClick={() => selectNextTab()}>
            Suivant
          </Button>
        )}
      </div>
    </div>
  );
}
